import React, { useState, useEffect } from "react";
import {
  Box,
  CardContent,
  Typography,
  IconButton,
  TextField,
  Button,
  FormControl,
  InputAdornment,
} from "@mui/material";

import axios from "axios";
import { API_BASE_URL } from "../../../apiConfig";
import TitleIcon from "@mui/icons-material/Title";
import DescriptionIcon from "@mui/icons-material/Description";
import ManageSign from "../sign/ManageSign";
import { refreshTokenIfNeeded } from "../refreshTokenIfNeeded";
import { useNavigate } from "react-router-dom";

//import { API_BASE_URL } from "../../../apiConfig";

export default function SiteInfoMange() {
  const [isLoading, setIsLoading] = useState(false);
  const [siteData, setSiteData] = useState({
    siteName: "",
    siteDescription: "",
    logoPath: "",
  });
  const navigate = useNavigate();

  const [imageFile, setImageFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    const fetchCarData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}SiteInfo/Find/${1}`);
        setSiteData(response.data);
        setSiteData({
          siteName: response.data.siteName || "",
          siteDescription: response.data.siteDescription || "",
          logoPath: response.data.logoPath || "",
        });
        setImageFile(response.data.logoPath);
        setPreviewImage(response.data.logoPath);
      } catch (error) {
        //alert("Failed to load car data.");
      }
    };

    fetchCarData();
  }, [1]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSiteData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file instanceof Blob) {
      const reader = new FileReader();
      reader.onload = () => {
        setSiteData((prevData) => ({
          ...prevData,
          logoPath: reader.result,
        }));
      };
      reader.readAsDataURL(file);
      setImageFile(file);
    } else {
      console.error("الملف غير صالح");
    }
    e.target.value = "";
  };

  const handleRemoveImage = () => {
    setSiteData((prevData) => ({
      ...prevData,
      logoPath: "",
    }));
    setImageFile(null);
  };

  const handleDescriptionChange = (value) => {
    setSiteData((prevData) => ({
      ...prevData,
      siteDescription: value,
    }));
  };

  const handleSubmit = async () => {
    if (!siteData.siteName || !siteData.siteDescription || !imageFile) {
      alert("يرجى ملء جميع الحقول.");
      return;
    }

    const token = localStorage.getItem("token");

    setIsLoading(true);

    const formData = new FormData();
    formData.append("siteName", siteData.siteName);
    formData.append("siteDescription", siteData.siteDescription);
    formData.append("logoPath", siteData.logoPath);

    if (imageFile) {
      formData.append("imageFile", imageFile);
    } else {
      formData.append("imageFile", previewImage);
    }

    try {
      await axios.put(`${API_BASE_URL}SiteInfo/Update/${1}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      alert("تم تعديل المتجر بنجاح");
    } catch (error) {
      if (error.response?.status === 401) {
        try {
          const newToken = await refreshTokenIfNeeded();

          if (!newToken) {
            return navigate("/", { replace: true });
          }

          // إعادة الطلب بالتوكن الجديد
          await axios.put(`${API_BASE_URL}SiteInfo/Update/${1}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${newToken}`,
            },
          });

          alert("تم تعديل المتجر بنجاح");
        } catch (retryError) {
          alert("Retry failed: " + retryError.message);
        }
      } else {
        // console.error(error);
        alert("حدث خطأ أثناء التعديل");
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div
        style={{
          background: "#272727",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "90vh",
        }}
      >
        <div
          style={{
            width: "40px",
            height: "40px",
            border: "4px solid #999",
            borderTop: "4px solid white",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        ></div>

        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  return (
    <div
      dir={"rtl"}
      style={{
        color: "white",
        maxWidth: "100%",
        maxHeight: "100%",
        fontFamily: "'Changa', sans-serif",
      }}
    >
      <h3>إعدادات الموقع - الإعلانات</h3>
      <div
        dir={"rtl"}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "7%",
          color: "#272727",
          background: "#f3f3f3",
          borderRadius: "7px",
          paddingLeft: "5px",
          paddingRight: "5px",
        }}
      >
        <Box>
          {/* تصميم العرض الجانبي للصورة والحقول */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: 3,
            }}
          >
            {/* الصورة على اليسار */}
            <Box
              sx={{
                width: "30%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* عرض الصورة أو النص الافتراضي */}
              <Box
                sx={{
                  width: 300,
                  height: 130,
                  marginTop: 2,
                  border: "1px solid #ccc",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  borderRadius: 3,
                  overflow: "hidden", // مهم عشان يخفي أي زوايا خارجية
                }}
              >
                {siteData.logoPath ? (
                  <img
                    src={siteData.logoPath}
                    alt="Preview"
                    style={{
                      width: "220px",
                      height: "auto",
                      objectFit: "cover",
                      borderRadius: "inherit",
                    }}
                  />
                ) : (
                  <Typography variant="body2" color="#272727">
                    لا يوجد شعار
                  </Typography>
                )}
              </Box>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "3%",
                  gap: "10px",
                }}
              >
                <Button variant="contained" component="label">
                  تحميل الشعار
                  <input type="file" hidden onChange={handleFileChange} />
                </Button>

                {/* زر إزالة الصورة */}
                {siteData.logoPath && (
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleRemoveImage} // استدعاء دالة إزالة الصورة هنا
                    //sx={{ mt: 2 }}
                  >
                    إزالة الشعار
                  </Button>
                )}
              </div>
            </Box>

            {/* الحقول على اليمين */}
            <Box sx={{ width: "65%" }}>
              <CardContent sx={{ textAlign: "right", mt: 1 }}>
                {/* حقول الإدخال */}
                <FormControl fullWidth sx={{ marginBottom: 1 }}>
                  <TextField
                    label="عنوان الموقع"
                    placeholder="عنوان الموقع"
                    value={siteData.siteName}
                    name="siteName"
                    onChange={handleChange}
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <TitleIcon sx={{ color: "blue" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>

                <FormControl fullWidth sx={{ marginBottom: 1 }}>
                  <TextField
                    label="وصف الموقع"
                    placeholder="وصف الموقع لمحركات البحث"
                    value={siteData.siteDescription}
                    name="siteDescription"
                    onChange={handleChange}
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <DescriptionIcon sx={{ color: "#1976d2" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </CardContent>
            </Box>
          </Box>

          <Box sx={{ textAlign: "center", mt: 0, marginBottom: 3 }}>
            <Button
              // disabled
              variant="contained"
              color="primary"
              sx={{ width: "15%" }}
              onClick={handleSubmit}
            >
              حفظ
            </Button>
          </Box>
        </Box>
      </div>
      <div
        style={{
          borderRadius: "7px",
          //  background: "#f3f3f3",
          background: "#e6e6e6",

          padding: "10px",
          marginTop: "1px",
        }}
      >
        <ManageSign />
      </div>
    </div>
  );
}
